var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvite = function SvgInvite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "invite_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".invite_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "invite_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "invite_svg__st1",
    d: "M9.5 13.84c3.25 0 5.89-2.64 5.89-5.89S12.75 2.06 9.5 2.06 3.61 4.7 3.61 7.95c0 3.25 2.64 5.89 5.89 5.89zm0-9.81c2.16 0 3.92 1.76 3.92 3.92s-1.76 3.92-3.92 3.92-3.92-1.76-3.92-3.92S7.33 4.03 9.5 4.03z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "invite_svg__st1",
    d: "M14.3 13.38a.959.959 0 0 0-.54-.17c-.33 0-.63.16-.82.43a.97.97 0 0 0-.15.74c.05.26.2.48.42.62 2.2 1.47 3.49 2.74 3.76 4.96H2.01c.26-2.34 1.5-3.62 3.51-4.96.45-.3.57-.91.27-1.36a.983.983 0 0 0-1.37-.26C1.77 15.16 0 17.13 0 20.96c0 .54.44.98.98.98h17.03c.54 0 .98-.44.98-.98 0-4.09-2.42-6.06-4.69-7.58zM23.02 9.58H21V7.56c0-.54-.44-.98-.98-.98s-.98.44-.98.98v2.02h-2.02c-.54 0-.98.44-.98.98s.44.98.98.98h2.02v2.02c0 .54.44.98.98.98s.98-.44.98-.98v-2.02h2.02c.54 0 .98-.44.98-.98s-.44-.98-.98-.98z"
  })));
};
export default SvgInvite;